// vue
import { reactive } from 'vue';
// helper
import Util from '@/helper/Utility';
// model
const state = reactive({
    channel: '',
    contact_number: '',
    expireIn: 0,
    otp: '',
    refcode: ''
});

const methods = {
    getParams: function () {
        let params = {
            channel: state.channel,
            contact_number: state.contact_number,
            otp: state.otp,
            refcode: state.refcode
        }

        return Util.cleanObjectEmptyStr(params);
    },
    setContactNumber: function (contact_number) {
        state.contact_number = contact_number;
    },
    setOtp: function (otp) {
        state.otp = otp;
    },
    setStateFromApi: function (otpModal) {
        state.channel = otpModal.channel;
        state.contact_number = otpModal.contact_number;
        state.expireIn = otpModal.expireIn;
        state.refcode = otpModal.refcode;
    },
    resetState: function () {
        state.channel = '',
        state.contact_number = '';
        state.expireIn = 0;
        state.otp = '';
        state.refcode = '';
    }
};

export default {
    state: state,
    methods: methods
};
